import parseHttpAction from './parseHttpAction';
import { ActionProvider } from 'owa-actionable-message';
import * as Adaptive from 'adaptivecards';

export default function parseDefaultLegacyMessageCardAction(
    jsonAction: any,
    actionProviders: ActionProvider[]
): Adaptive.Action {
    switch (jsonAction['@type']) {
        case 'HttpPOST':
            return parseHttpAction(jsonAction);
    }

    return null;
}
